import { useSelector } from "react-redux";
import MovieList from "./MovieList";

const SecondaryContainer = () => {
  const movies = useSelector((store) => store.movies);
  return (
    movies.nowPlayingMovies && (
      <div className="relative z-20 -mt-16">
        {/* Now Playing overlaps the hero - transparent bg */}
        <div className="text-white">
          <MovieList title={"Now Playing"} movies={movies.nowPlayingMovies} />
        </div>
        {/* Remaining sections on solid black */}
        <div className="bg-black text-white">
          <MovieList title={"Popular"} movies={movies.popularMovies} />
          <MovieList title={"Trending"} movies={movies.trendingMovies} />
          <MovieList title={"Upcoming Movies"} movies={movies.upComingMovies} />
        </div>
      </div>
    )
  );
};

export default SecondaryContainer;
